import { render, staticRenderFns } from "./VolatilityArea.vue?vue&type=template&id=1596345c&scoped=true&"
import script from "./VolatilityArea.vue?vue&type=script&lang=js&"
export * from "./VolatilityArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596345c",
  null
  
)

export default component.exports